import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tempToken: "",
  phoneNumber: "",
  code: "",
};
export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      if (action.payload.tempToken) {
        state.tempToken = action.payload.tempToken;
      }
      if (action.payload.phoneNumber) {
        state.phoneNumber = action.payload.phoneNumber;
      }
      if (action.payload.code) {
        state.rank = action.payload.code;
      }
   
    },
  },
});
export const { setAuthData } = authSlice.actions;

export default authSlice.reducer;